export default {
      id: "icon-instagram-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-instagram",
      toString: function () {
        return this.url;
      }
    }